module.exports = __webpack_public_path__ + "static/media/daveed.6d75964b.png";